import React from "react";
import styled, { css } from "styled-components";
import { narrowScreenMediaQuery } from "../constants/styles";
import { notif_icon_src } from "../images/index";
import { white } from "../constants/styles";
import { apiGet } from "../api";

const useNotifications = (props) => {
  const [notifications, setNotifications] = React.useState([]);
  const refreshNotifications = React.useCallback(async () => {
    const { parsedResponse } = await apiGet("/api/v1/users/notifications");
    if (Array.isArray(parsedResponse)) {
      setNotifications(parsedResponse);
    }
  });
  React.useEffect(() => {
    refreshNotifications();
    const t = setInterval(() => {
      refreshNotifications();
    }, 1000 * 60); // 1 minute
    return () => {
      clearInterval(t);
    };
  }, []);

  return { notifications };
};

const UnnamedComponent = (props) => {
  const { notifications } = useNotifications();

  return (
    <NotifButton>
      <img src={notif_icon_src} />
      <NotifBox>
        <NotifTitle>Notifikasi</NotifTitle>
        {notifications.map(({ id, ...n }) => (
          <NotifItemLink
            key={id}
            href={n.url}
            {...(!n.url.includes("learning.taxsam.co") && {
              target: "_blank",
            })}
          >
            <NotifItemIconDiv>
              <img src={notif_icon_src} />
            </NotifItemIconDiv>
            <NotifItemContentDiv>
              <NotifItemTime>{n.time_text}</NotifItemTime>
              <NotifItemTitle>{n.title}</NotifItemTitle>
              <NotifItemDesc>{n.content}</NotifItemDesc>
            </NotifItemContentDiv>
          </NotifItemLink>
        ))}
        {notifications.length == 0 && (
          <NotifMessage>belum ada notifikasi</NotifMessage>
        )}
      </NotifBox>
    </NotifButton>
  );
};
export default UnnamedComponent;

const NotifMessage = styled.div`
  font-size: 12px;
  text-align: center;
  margin: 10px 0;
`;

const NotifTitle = styled.div`
  font-weight: bold;
  padding-bottom: 4px;
  border-bottom: 1px solid grey;
  margin-left: 10px;
  margin-right: 10px;
  margin-bottom: 10px;
`;

const NotifItemLink = styled.a`
  align-items: start;
  color: white;
  cursor: pointer;
  display: flex;
  gap: 10px;
  margin-bottom: 5px;
  padding: 10px;
  text-decoration: unset;

  &:hover {
    background-color: #3d3f40;
  }
`;

const NotifItemIconDiv = styled.div``;

const NotifItemContentDiv = styled.div`
  font-size: 14px;
`;

const NotifItemTime = styled.div`
  color: #babec1;
  font-size: 13px;
  margin-bottom: 6px;
`;

const NotifItemTitle = styled.div`
  margin-bottom: 5px;

  ${NotifItemLink}:hover & {
    text-decoration: underline;
  }
`;

const NotifItemDesc = styled.div`
  font-size: 12px;
`;

const arrowDown = css`
  border-bottom: 0;
  border-left: 0.3em solid transparent;
  border-right: 0.3em solid transparent;
  border-top: 0.3em solid;
  color: ${white};
  content: "";
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
`;

export const NotifButton = styled.div`
  align-items: center;
  border-radius: 7px;
  cursor: pointer;
  display: flex;
  max-height: 38px;
  padding: 5px;
  position: relative;

  &:after {
    ${arrowDown};
  }

  &:hover {
    box-shadow: 1px 1px 2px #000000;

    &::after {
      transform: rotate(-180deg);
      transition: transform 0.2s;
    }
  }

  &:focus-visible {
    outline: none;
  }

  ${(props) =>
    props.$noArrow &&
    css`
      &:after {
        display: none;
      }
    `};

  ${(props) =>
    props.$shownWhenNarrow &&
    css`
      display: none;

      @media ${narrowScreenMediaQuery} {
        display: block;
      }
    `};
`;

const NotifBox = styled.div`
  background-color: #2f2f2f;
  color: ${white};
  cursor: default;
  display: none;
  max-height: 500px;
  overflow-y: auto;
  padding: 10px 0;
  position: absolute;
  right: 0;
  top: 35px;
  width: 300px;
  z-index: 1;

  ${NotifButton}:hover > & {
    display: block;
  }
`;
